module.exports = __webpack_public_path__ + "static/media/facebook.37edd616.svg";